import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import the design system styles and components
import '@om-design-system/web-components/dist/om-design-system-web/om-design-system-web.css';
import { defineCustomElements } from '@om-design-system/web-components/loader';

// Register the custom elements
defineCustomElements(window);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
